import { memo } from 'react';

import FilterDealsComponent from './FilterDealsComponent.react';
import FiltersLoader from './FiltersLoader.jsx';

const FilterDealsSection = ({
	numHotelDeals,
	postPayDealsExists,
	halfBoardDealsExists,
	allInclusiveDealsExists,
	bnplDealsExists,
	travelPolicy,
	isRtl,
	dealsLoading,
	onFreeCancellationToggle,
}) => {
	if (numHotelDeals === 0 && !dealsLoading) {
		return null;
	}

	return numHotelDeals > 0 ? (
		<FilterDealsComponent
			post_pay_deals_exists={postPayDealsExists}
			half_board_deals_exists={halfBoardDealsExists}
			all_inclusive_deals_exists={allInclusiveDealsExists}
			bnpl_deals_exists={bnplDealsExists}
			travel_policy={travelPolicy}
			onFreeCancellationToggle={onFreeCancellationToggle}
		/>
	) : (
		<FiltersLoader isRtl={isRtl} />
	);
};

export default memo(FilterDealsSection);
